import classNames from 'classnames';
import React, { useReducer } from 'react';
import { LookupValueDTO } from '../../../common/types/dto/LookupValueDTO';
import DealerDistrictSelect from '../../common/Components/DealerDistrictSelect';
import PacksInfo from '../../valueandcare/components/PacksInfo';

interface PackValueServiceContainerProps {
    licensePlate: string;
    vin: string;
    vehcode: number;
}
interface PackValueServiceState {
    dealerCode: number;
}

const PackValueService: React.FC<PackValueServiceContainerProps> = (Props) => {
    const initialState: PackValueServiceState = {
        dealerCode: 0,
    };
    const [state, setState]: [PackValueServiceState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    function onDealerChange(selected: LookupValueDTO<number>) {
        if (selected) {
            setState({
                dealerCode: selected.value,
            });
        } else {
            setState({ dealerCode: 0 });
        }
    }

    return (
        <React.Fragment>
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-pacotes', 'dados-pacotes'])}>
                <div className="row">
                    <div className={classNames(['columns', 'medium-12', 'padding-left-0', 'padding-right-0'])}>
                        <div className={classNames(['grid-container', 'fluid', 'padding-left-0'])}>
                            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                <DealerDistrictSelect
                                    validation={true}
                                    onChange={onDealerChange}
                                    staticDealerCode={0}
                                    disbaleSelectorOnSubmit={false}
                                    sideBySideSelectorsDisplay={true}
                                    divClassName={classNames(['cell', 'medium-6', 'small-12'])}
                                />
                            </div>
                        </div>
                        <PacksInfo vehcode={Props.vehcode} dealerCode={state.dealerCode} vin={Props.vin} licensePlate={Props.licensePlate} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PackValueService;
